import React, { ChangeEvent, FC, useContext, useEffect, useState } from "react";
import { AppContext } from "../../appContext/AppContext";
import { CODE, DEFAULT_PAGE_INDEX, KEY, SELECTION_MODE, TYPE, WF_TRACKER } from "../../utils/Constant";
import { Button } from "react-bootstrap";
import TextField from "../../component/TextField";
import InputSearch from "../../component/InputSearch";
import { TablePagination } from "../../component/table/components/TablePagination";
import { handlePagesChange, handleRowsPerPageChange, rowsForPage } from "../../utils/PageUtils";
import WfStatusSummary from "../../workflows/components/WfStatusSummary";
import { ConfirmDialog } from "../../component/ConfirmDialog";
import { toast } from "react-toastify";
import { getSummaryStatusByType } from "../../workflows/services/WfWorkflowsService";
import { formatDateFromDTOCustom, formatDateToDTOCustom } from "../../utils/AppFunction"
import { getListLoaiPhieuChiDinh, getListPhieuChiDinh, getListVisitObject, tongHopPhieuServices } from "../services/TongHopPhieuServices"
import AutocompleteObjectV2 from "../../component/AutocompleteObjectV2";
import { ColumnsDanhSachPhieu } from "../constants/TongHopPhieuColumns";
import OctTableCollapse from "../../component/table/table-collapse-custom/OctTableCollapse";
import { getListWarehouse } from "../../utils/ServicesUtils";
import FormInPhieuDialog from "../../component/button-in-phieu/components/PrintDialog";
import { HOAN_TRA_DVKT, trackerCode } from "../Constant";
import { localStorageItem } from "../../utils/LocalStorage";
import { KEY_LOCALSTORAGE } from "../../auth/core/_consts";
import CustomIconButton from "../../component/custom-icon-button/CustomIconButton";
import DialogSuaPhieuHoanTra from "./DialogSuaPhieuHoanTra";
import WfButton from "../../workflows/components/WfButton";
import { EXPORT_CODE } from "../../phan-he-xuat-kho/constants/constantsXuatKho";
import {formatDateToYYYYMMDD} from "../../utils/FormatUtils";


type Props = {
  modelId?: any;
}

export const DanhSachDonChiDinh: FC<Props> = (props) => {
  const { modelId } = props;
  const SITE = process.env.REACT_APP_SITE;
  const { setIsLoading } = useContext(AppContext);
  const [dsPhieu, setDsPhieu] = useState([]);
  const [lstWarehouse, setLstWarehouse] = useState<any>([]);
  const [lstVisitObject, setLstVisitObject] = useState<any>([]);
  const [warehouse, setWarehouse] = useState<any>();
  const [openDialogConfirmTongHop, setOpenDialogConfirmTongHop] = useState<boolean>(false);
  const [openDialogHoanTra, setOpenDialogHoanTra] = useState<boolean>(false);
  const [itemSelected, setItemSelected] = useState<any>([]);
  const [searchData, setSearchData] = useState<any>({
    doCreationFromDate: formatDateToYYYYMMDD(new Date()),
    doCreationToDate: formatDateToYYYYMMDD(new Date())
  });
  const [rowDataSelect, setRowDataSelect] = useState();
  const [clearCheckbox, setClearCheckbox] = useState<any>(false);
  const [rowsPerPage, setRowsPerPage] = useState<number>(20);
  const [page, setPage] = useState<number>(DEFAULT_PAGE_INDEX);
  const [summaryStatus, setSummaryStatus] = useState<any>([]);
  const [warehouseExportType, setWarehouseExportType] = useState<any>();
  const [visitObjectType, setVisitObjectType] = useState<any>();
  const [options, setOptions] = useState<any>([]);
  const [status, setStatus] = useState(null);

  const [configTable, setConfigTable] = useState<any>({
    totalPages: 0,
    totalElements: 0,
    numberOfElements: 0,
  });
  const [openPrintDialog, setOpenPrintDialog] = useState(false);

  useEffect(() => {
    updatePageData();
  }, [page, rowsPerPage, warehouseExportType, warehouse, visitObjectType, searchData]);


  useEffect(() => {
    setSearchData({
      ...searchData,
      slipStatus: status,
    })
  }, [status]);
  const updateListWarehouse = async () => {
    try {
      const data = await getListWarehouse();
      setLstWarehouse(data);
      // setWarehouse(data[0]);
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    updateListWarehouse();
    updateListVisitObject();
  }, []);


  const updateListVisitObject = async () => {
    try {
      const data = await getListVisitObject();
      setLstVisitObject(data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    const getList = async () => {
      try {
        setIsLoading(true);
        const { data } = await getListLoaiPhieuChiDinh();
        if (CODE.SUCCESS === data.code) {
          setOptions(data.data);
          setWarehouseExportType(data.data[0])
        } else {
          toast.error('Có lỗi xảy ra, vui lòng thử lại')
        }
      } catch (error) {
        console.error(error);
      } finally {
        setIsLoading(false);
      };
    };
    getList();
  }, [])

  const handleChangeSearchData = (e: ChangeEvent<HTMLInputElement>) => {
    setSearchData({
      ...searchData,
      [e.target.name]: e.target.value,
    });
  };

  const handlerSearchKeyWorld = () => {
    setPage(DEFAULT_PAGE_INDEX);
    setRowsPerPage(20);
    updatePageData()
  }
  const updatePageData = async () => {
    if (!warehouseExportType?.code) return
    let accessToken = localStorageItem.get(KEY_LOCALSTORAGE.ACCESS_TOKEN_DECODE);
    const departmentNames = accessToken?.department;
    try {
      setIsLoading(true);
      const { data } = await getListPhieuChiDinh({
        ...searchData,
        slipStatus: status,
        doCreationFromDate: formatDateFromDTOCustom(searchData?.doCreationFromDate) || null,
        doCreationToDate: formatDateToDTOCustom(searchData?.doCreationToDate) || null,
        pageSize: rowsPerPage,
        pageIndex: page,
        type: 16,
        warehouseExportType: warehouseExportType?.code,
        warehouseId: warehouse?.id,
        visitObjectTypeName: visitObjectType?.name,
        departmentName: departmentNames,
        isFilteredByDepartment: accessToken?.department ? true : false,
        trackerCode: warehouseExportType?.code == "HTTDT" ? warehouseExportType.description : "",

      });
      // if (warehouseExportType?.tracker && warehouseExportType?.type) {
      const tracker = warehouseExportType?.description || trackerCode?.issue_orders_export
      const resSummary = await getSummaryStatusByType(
        tracker,
        16,
        {
          visitObjectTypeName: visitObjectType?.name,
          warehouseId: warehouse?.id,
          warehouseExportType: warehouseExportType?.code,
          fromDate: formatDateFromDTOCustom(searchData?.doCreationFromDate) || null,
          toDate: formatDateToDTOCustom(searchData?.doCreationToDate) || null,
        }
      );
      CODE.SUCCESS === resSummary?.data?.code && setSummaryStatus(resSummary.data.data);
      // }


      if (CODE.SUCCESS === data.code) {
        setDsPhieu(data?.data?.content);
        setConfigTable({
          totalPages: Math.ceil(data.data.pageable.totalElements / data.data.pageable.pageSize),
          totalElements: data.data.pageable.totalElements,
          numberOfElements: data.data.pageable.pageSize,
        });
      } else {
        toast.error('Lỗi tìm kiếm phiếu, vui lòng thử lại');
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCloseDialog = () => {
    setOpenDialogConfirmTongHop(false);
    setOpenPrintDialog(false);
    setOpenDialogHoanTra(false);
    setClearCheckbox(true);
    setItemSelected([]);
    updatePageData();
  };

  const handleTongHop = async () => {
    setOpenPrintDialog(true);
    // try {
    //   setIsLoading(true);
    //   const { data } = await tongHopPhieuServices({
    //     listMaterialBudget: itemSelected,
    //      warehouseExportType: warehouseExportType?.code,
    //   });
    //   if (CODE.SUCCESS === data.code) {
    //     handleCloseDialog();
    //   } else {
    //     toast.error('Có lỗi xảy ra, vui lòng thử lại');
    //   }
    // } catch (error) {
    //   console.error(error);
    // } finally {
    //   setIsLoading(false);
    // }
  };

  const handleSelectData = (row: any) => {
    if (row.length) {
      setItemSelected(row?.map((item: any) => item?.id));
    } else {
      setItemSelected([])
    }
  };
  // console.log(itemSelected)
  const handleChangeSelect = (data: any) => {
    setWarehouseExportType(data);
    // setSearchData({})
  };

  const handleChangeSelectVisitObject = (data: any) => {
    setVisitObjectType(data);
    console.log(data)
    // setSearchData({})
  };

  const handleChangeSelectWarehouse = (data: any) => {
    setWarehouse(data);
    // setSearchData({})
  };

  const handleOpenDialogTongHop = () => {
    setClearCheckbox(false);
    setOpenDialogConfirmTongHop(true)

  }

  const onClickStatus = (item: any) => {
    setStatus(() => item?.statusCode === status ? null : item?.statusCode)
  }

  return (
    <div className="bg-white h-100">
      <div className="flex-1 flex flex-column">
        <div className="d-flex bg-gray ">
          <div className="spaces width-100 bg-gray radius-2">
            <div className="flex bg-white spaces width-100 justify-content-between" >
              <div className="flex bg-white spaces width-100" >
                <h4 className="text-title text-pri fw-bold fs-4 spaces mb-0  px-10">
                  {`Danh sách ${modelId.title}`}
                </h4>
                <div className="flex bg-white spaces width-20 mt-2 ml-12" >
                  <AutocompleteObjectV2
                    options={[...options]}
                    isSearchDefauilt={true}
                    name={"warehouseExportType"}
                    onChange={(options: any) => handleChangeSelect(options)}
                    value={warehouseExportType || ""}
                    className="autocomplete-custom-renderform  radius spaces width-100 h-29"
                    isClearable={false}
                  />
                </div>
              </div>
            </div>
            <div className="d-flex mt-1 flex-column spaces width-100">
              <div className="bg-white">
                <div className="d-flex spaces pr-8 mt-6 bg-white justify-content-between align-items-center mb-6">
                  <div className=" bg-white flex align-items-center ">
                    <Button
                      className="btn-fill  ml-10 spaces min-w-90px btn btn-primary"
                      onClick={() => handleOpenDialogTongHop()}
                      disabled={!itemSelected?.length}
                    >
                      Tổng hợp
                    </Button>
                  </div>
                  <h4 className="fs-4 spaces mb-0  px-5">
                    {`Kho`}
                  </h4>
                  <div className="flex bg-white spaces width-20  ml-5" >
                    <AutocompleteObjectV2
                      options={lstWarehouse}
                      isSearchDefauilt={true}
                      name={"WmsCode"}
                      onChange={(options: any) => handleChangeSelectWarehouse(options)}
                      value={warehouse || ""}
                      className="autocomplete-custom-renderform  radius spaces width-100 h-29"
                      isClearable={true}
                    />
                  </div>
                  <h4 className="fs-4 spaces mb-0  px-5">
                    {`Loại đối tượng`}
                  </h4>
                  <div className="flex bg-white spaces width-20  ml-5" >
                    <AutocompleteObjectV2
                      options={[...lstVisitObject]}
                      isSearchDefauilt={true}
                      name={"visitObjectType"}
                      onChange={(options: any) => handleChangeSelectVisitObject(options)}
                      value={visitObjectType || ""}
                      className="autocomplete-custom-renderform  radius spaces width-100 h-29"
                      isClearable={false}
                    />
                  </div>
                  <div className="d-flex spaces mx-10 ">
                    <TextField
                      label="Từ ngày"
                      name="doCreationFromDate"
                      type="date"
                      value={searchData?.doCreationFromDate || ''}
                      className="flex"
                      labelClassName="spaces mt-5 mr-5"
                      onChange={handleChangeSearchData}
                    />
                  </div>
                  <div className="d-flex spaces mr-10">
                    <TextField
                      label="Đến ngày"
                      name="doCreationToDate"
                      type="date"
                      className="flex"
                      value={searchData?.doCreationToDate || ''}
                      labelClassName="spaces mt-5 mr-5"
                      onChange={handleChangeSearchData}
                    />
                  </div>
                  <div className="flex-grow-1 ">
                    <InputSearch
                      name="keyword"
                      value={searchData?.keyword || ''}
                      placeholder="Tìm kiếm"
                      handleChange={handleChangeSearchData}
                      handleSearch={handlerSearchKeyWorld}
                      handleKeyDown={(e: React.KeyboardEvent) => e.key === KEY.ENTER && handlerSearchKeyWorld()}
                      className="spaces h-31 pr-4  radius-3"
                    />
                  </div>
                </div>
                <div className=" spaces bg-white mb-0 table-xuat-thuoc">
                  <OctTableCollapse
                    data={dsPhieu}
                    columns={ColumnsDanhSachPhieu}
                    searchObject={searchData}
                    setSearchObject={setSearchData}
                    updateTableData={updatePageData}
                    nameChildren="subs"
                    isSelect
                    // noAction
                    noToolbar
                    isOneLevelCheckBox
                    isLevel
                    selectionMode={SELECTION_MODE.MULTI}
                    setData={(value: any) => { }}
                    selectData={handleSelectData}
                    // customFieldParent={["name", "weight", "height", "doctorName", "doCreation", "diagnosisCode", "comorbidity"]}
                    // customFieldParent={[{ field: "name"},{ field: "height"},{ field: "weight"},{ field: "patientName"},{ field: "doCreation", type: TYPE.DATE}, { label:"MÃ ICD", field: "diagnosisCode"},{ field: "comorbidity"}]}
                    customFieldParent={[{ field: "patientCode" }, { field: "patientName" }, { field: "patientGenderName" }, { field: "visitCode" }, { label: "Tuổi", field: "age" }, { field: "height" }, { field: "weight" }, { field: "doCreation", type: TYPE.DATE }, { label: "MÃ ICD", field: "diagnosisCode" }, { field: "comorbidity" }]}
                    handleSetShowCheckBox={(row: any) => row?.statusCode === "warehouse_export_start"}
                    actionColumnComponent={(rowData) => (
                      <>
                        {(warehouseExportType?.code == EXPORT_CODE.HOAN_TRA && rowData?.statusCode === "warehouse_done") ? (
                          <div className="mt-2">
                            <CustomIconButton onClick={() => {
                              setRowDataSelect(rowData);
                              setOpenDialogHoanTra(true)
                            }}
                              variant="edit"
                              tooltip="Hoàn trả"
                            >
                              {/* <span>Hoàn trả</span> */}
                              <i
                                className="bi bi-arrow-counterclockwise text-danger fs-1 pt-5 mt-5"

                              >
                              </i>
                            </CustomIconButton>
                          </div>
                        ) : <></>}
                        {"HTTDT" == warehouseExportType?.code && rowData?.id &&
                          <WfButton
                            key={rowData?.id}
                            tracker={warehouseExportType.description} // button
                            objectId={rowData?.id}
                            workFlowsDefault={rowData?.nextStatuses}
                            // type={1}
                            iscallWf={false}
                            additionalFunc={(data) => {
                              // setStatusPhieu({
                              //   status: data?.currCode
                              // })
                              // data?.currCode && setFieldValue(`${modelId.id}.statusCode`, data?.currCode)
                            }}
                          />
                        }
                      </>
                    )}
                  />

                  {/*<TableCustom<any>*/}
                  {/*  className="spaces h-calc-vh-250"*/}
                  {/*  data={dsPhieu}*/}
                  {/*  isHiddenCheckall={true}*/}
                  {/*  isClearSelect={clearCheckbox}*/}
                  {/*  columns={DanhSachPhieuColumns}*/}
                  {/*  getSelectedRowsData={handleSelectData}*/}
                  {/*  // columnsActions={columnsActions}*/}
                  {/*  verticalScroll={true}*/}
                  {/*  selectionMode={SELECTION_MODE.MULTI}*/}
                  {/*/>*/}
                  <TablePagination
                    handlePagesChange={handlePagesChange}
                    handleRowsPerPageChange={handleRowsPerPageChange}
                    rowsPerPage={rowsPerPage}
                    rowsForPage={rowsForPage}
                    page={page}
                    setPage={setPage}
                    setRowsPerPage={setRowsPerPage}
                    totalPages={configTable.totalPages}
                    totalElements={configTable.totalElements}
                    numberOfElements={configTable.numberOfElements}
                    hideTotalElements
                    customComponent={<WfStatusSummary summaryStatus={summaryStatus} col={2} onClick={onClickStatus} />}
                    customComponentClassName="min-w-912"
                    className="border border-0"
                  />
                </div>
              </div>
            </div>
          </div>
          {openDialogConfirmTongHop &&
            <ConfirmDialog
              show={openDialogConfirmTongHop}
              onCloseClick={handleCloseDialog}
              onYesClick={handleTongHop}
              title="Tổng hợp phiếu"
              message={`Bạn chắc chắn muốn tổng hợp?`}
              yes="Xác nhận"
              close="Hủy"
            />
          }
          {openDialogHoanTra &&
            <DialogSuaPhieuHoanTra show={openDialogHoanTra} onHide={handleCloseDialog} initialValues={rowDataSelect} />
          }

          {openPrintDialog && (
            <FormInPhieuDialog
              show={openPrintDialog}
              onHide={handleCloseDialog}
              fetchExport={tongHopPhieuServices}
              params={{
                listMaterialBudget: itemSelected,
                warehouseExportType: warehouseExportType?.code,
              }}
              shouldNotShowLabelExport
              shouldNotShowExportPDF
              shouldNotShowExportDOC
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default DanhSachDonChiDinh;
